// removed by extract-text-webpack-plugin
module.exports = {"content":"_3vhbew5BqW1oHRZox0TwZ1","information":"_3QOjO_6gVA0bSl0JbptRiW","badge":"iK1hlOhmgF96C62Jt30-S","media":"_3XkMKK1S_y7Mmd0PvjwmzW"};


//////////////////
// WEBPACK FOOTER
// ../components/project/description/styles.module.css
// module id = 593
// module chunks = 0